module.exports = __webpack_public_path__ + "img/sort-filter-gray.aa108e91.svg";